import { useEffect, useState } from "react";

const START = new Date(2026, 8, 28, 0, 0, 0);

const diff = () => {
  const ms = Math.max(0, START - Date.now());
  return {
    days: Math.floor(ms / 86400000),
    hours: Math.floor((ms / 3600000) % 24),
    mins: Math.floor((ms / 60000) % 60),
    secs: Math.floor((ms / 1000) % 60),
    done: ms === 0,
  };
};

const pad = (n) => String(n).padStart(2, "0");

export default function Countdown() {
  const [t, setT] = useState(diff);
  useEffect(() => {
    const id = setInterval(() => setT(diff()), 1000);
    return () => clearInterval(id);
  }, []);

  if (t.done) {
    return (
      <p data-testid="hero-countdown-started" className="font-display font-extrabold text-2xl text-[#1B2FD8]">
        THE RESET HAS BEGUN.
      </p>
    );
  }

  const units = [["DAYS", t.days], ["HRS", t.hours], ["MIN", t.mins], ["SEC", t.secs]];
  return (
    <div data-testid="hero-countdown" className="flex items-end gap-4 sm:gap-6">
      <p className="text-[10px] sm:text-xs font-semibold uppercase tracking-[0.25em] text-[#4A4A66] self-center max-w-[70px] leading-tight">
        Reset starts in
      </p>
      {units.map(([label, val], i) => (
        <div key={label} className="flex items-end gap-4 sm:gap-6">
          <div className="text-center">
            <p data-testid={`countdown-${label.toLowerCase()}`} className="font-display font-extrabold text-3xl sm:text-4xl lg:text-5xl leading-none text-[#0B0B12] tabular-nums">
              {pad(val)}
            </p>
            <p className="mt-1 text-[9px] sm:text-[10px] uppercase tracking-[0.25em] text-[#1B2FD8] font-semibold">{label}</p>
          </div>
          {i < units.length - 1 && <span className="font-display text-2xl sm:text-3xl text-[#1B2FD8]/50 pb-4">:</span>}
        </div>
      ))}
    </div>
  );
}
